import { useCurrentUser } from '@cosuno/authentication-frontend';
import { useEffect } from 'react';

import useAnalytics from '~/shared/hooks/useAnalytics';
import { env } from '~/shared/utils/env';
import injectScript, { injectInlineScript } from '~/shared/utils/injectScript';

import { getNavatticLightboxElementFromEvent, shouldCloseNavatticLightboxOnEvent } from './utils';

export const useNavatticSetup = () => {
  const user = useCurrentUser();
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    if (env.REACT_APP_CYPRESS === 'true') {
      return;
    }

    injectScript({ src: 'https://js.navattic.com/embeds.js', async: true });
    injectScript({ src: 'https://js.navattic.com/embed-events.js', async: true });
    injectInlineScript(
      'navattic-queue-2ec98d2e-da48-444a-a4d8-f2189e735c2b',
      'void 0===window.navatticQueue&&(window.navatticQueue=[],window.navattic=new Proxy({},{get:function n(t,u,e){return function(){for(var n=arguments.length,t=Array(n),e=0;e<n;e++)t[e]=arguments[e];return navatticQueue.push({function:u,arguments:t})}}}));',
    );
  }, []);

  useEffect(() => {
    if (env.REACT_APP_CYPRESS === 'true') {
      return;
    }

    if (window.navattic && user) {
      window.navattic.identify({
        id: user.id,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        company: {
          id: user.company.id,
          name: user.company.name,
        },
      });
      window.navattic.onEvent((event: object) => {
        trackEvent('navatticEvent', event);

        if (shouldCloseNavatticLightboxOnEvent(event)) {
          const lightbox = getNavatticLightboxElementFromEvent(event);
          lightbox?.close();
        }
      });
    }
  }, [trackEvent, user]);
};
